/*******************************************************************

*THESE MATERIALS CONTAIN CONFIDENTIAL INFORMATION AND TRADE SECRETS 

*OF BMC SOFTWARE, INC. YOU SHALL MAINTAIN THE MATERIALS AS

*CONFIDENTIAL AND SHALL NOT DISCLOSE ITS CONTENTS TO ANY THIRD

*PARTY EXCEPT AS MAY BE REQUIRED BY LAW OR REGULATION. USE, 

*DISCLOSURE, OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR 

*EXPRESS WRITTEN PERMISSION OF BMC SOFTWARE, INC. 

 

*ALL BMC SOFTWARE PRODUCTS LISTED WITHIN THE MATERIALS ARE TRADEMARKS

*OF BMC SOFTWARE, INC. ALL OTHER COMPANY PRODUCT NAMES ARE

*TRADEMARKS OF THEIR RESPECTIVE OWNERS. 

 

© Copyright 2020 BMC Software, Inc. 

*******************************************************************/

//this closure ensures we won't be interfering with other libraries that have defined $
(function($) {
    var toggleDataTemplate = {};
    var hostConnectionsTable = {};
    var displayRecords = 25;
    var groups = [];
    var groupsTable = null;
    var ANIMATION_SPEED = 250;
    var descriptions = [];
    var hostData = null;
    var originalDescription = null;
    var descriptionEdited = false;
    var hostNameEdited = false;
    var portEdited = false;
    
    var sortGroups = function(first, second) {
        var firstName = first.name.toString().toUpperCase();
        var secondName = second.name.toString().toUpperCase();
        
        if (firstName === secondName) {
            return 0;
        }
        
        if (firstName < secondName) {
            return -1;
        }
        
        return 1;
    };
    
    var renderGroupCell = function(data, type, row, meta) {
        var name = data;
        
        if (!!name && type === 'display') {
            var cellData = {
                id : meta.col === 0 ? row.idOne : row.idTwo,
                name : meta.col === 0 ? row.nameOne : row.nameTwo,
                checked : meta.col === 0 ? row.checkedOne : row.checkedTwo
            };
            
            name = Mustache.to_html(toggleDataTemplate, {data: cellData})                            
        }
        
        return name;
    };
    
    var findGroup = function(groupArray, name) {
        var matchingGroup = null;
        
        if (!$.isArray(groupArray)) {
            groupArray = [groupArray];
        }
        
        for (var index = 0; index < groupArray.length; index++) {
            var group = groupArray[index];
            
            if (group.groupName === name) {
                matchingGroup = group;
                break;
            }
        }
        
        return matchingGroup;
    };
    
    var populateGroupsTable = function() {
        var groupsCopy = groups.concat().sort(sortGroups);
        var groupRow = {};
        var groupsTableData = [];
        
        for (var index = 0; index < groupsCopy.length; index++) {
            var group = groupsCopy[index];
            
            if (index % 2 === 0) {
                // first column
                groupRow.nameOne = group.name;
                groupRow.idOne = group.id;
                groupRow.checkedOne = false;
                
                if (!!hostData && !!hostData.group && !!findGroup(hostData.group, group.name)) {
                    groupRow.checkedOne = true;
                }
            } else {
                // second column
                groupRow.nameTwo = group.name;
                groupRow.idTwo = group.id;
                groupRow.checkedTwo = false;
                
                if (!!hostData && !!hostData.group && !!findGroup(hostData.group, group.name)) {
                    groupRow.checkedTwo = true;
                }
                
                groupsTableData.push(groupRow);
                groupRow = {};
            }
        }
        
        if (!!groupRow.nameOne) {
            // we didn't have a full row so add it to the array
            groupsTableData.push(groupRow);
        }
        
        if (groupsTable === null) {
            groupsTable = $('#groupsTable').DataTable({
                processing : false,
                ordering : false,
                data : groupsTableData,
                columns : [
                    {
                        data : 'nameOne',
                        render : renderGroupCell,                   
                        defaultContent : '',
                        width: '50%'
                    },
                    {
                        data : 'nameTwo',
                        render : renderGroupCell,                   
                        defaultContent : '',
                        width: '50%'
                    }
                ],
                dom : 'Rt<"#groupsRowCount"l><"#groupsPagination"p>',
                paginate : true,
                lengthChange : true,
                autoWidth : false,
                paginationType : "full_numbers",
                displayLength : 12, 
                language : {
                    paginate : {
                        first : firstPaginationText,
                        previous : previousPaginationText,
                        next : nextPaginationText,
                        last : lastPaginationText
                    },
                    lengthMenu: showLabelText + '<select>' +
                    '<option value="5">' + count10Text + '</option>' +
                    '<option value="12">' + count25Text + '</option>' +
                    '<option value="25">' + count50Text + '</option>' +
                    '<option value="50">' + count100Text + '</option>' +
                    '<option value="250">' + count500Text + '</option>' +
                    '<option value="-1">' + countAllText + '</option>' +
                    '</select>' + groupsLabelText
                },
                stateSave : true,
                stateSaveCallback : function(settings, data) {
                    localStorage.setItem('groupsTable_' + settings.sInstance, JSON.stringify(data));
                },
                stateLoadCallback : function(settings) {
                    return $.fn.loadTableState(settings, 'groupsTable_');                 
                },
                initComplete : function() {
                    var rowCountWidget = $('#groupsRowCount');
                    rowCountWidget.addClass('row-count');
                    rowCountWidget.appendTo('.groups-table.pagination-controls');
                    
                    var paginationWidget = $('#groupsPagination');
                    paginationWidget.addClass('pagination');
                    paginationWidget.appendTo('.groups-table.pagination-controls');
                },
            });
            
            $('#filterGroups').click($.handleFilterClicked);
            $('#filterGroupsInput').keyup(function() {
                $.filterTable(groupsTable, $(this).val());
            });
        } else {
            groupsTable.clear();
            groupsTable.rows.add(groupsTableData);
            groupsTable.draw();
        }
    };

    var addRow = function(data) {
        $.displayLoadingIndicator(addingText);
        
        $.ajax({
            type: 'POST',
            data: JSON.stringify(data),
            url : 'ws/Config/hostConnections',
            dataType : 'json',
            contentType : 'application/json',
            cache : false
        }).done(function(success){
        	if(success) {
        		 hostConnectionsTable.row.add(data);
                 hostConnectionsTable.draw();
                 $.showSuccessStatus(addHciSuccessText);
        	} else {
        		$.showErrorStatus(addHciErrorText);
        	}
        }).fail(function(msg){
        	$.showErrorStatus(msg.responseText);
        }).always(function(){
        	$.removeLoadingIndicator();
        });
    };
    
    var updateRow = function(data, skipMessage) {
        return $.ajax({
            type: 'PUT',
            data: JSON.stringify(data),
            url : 'ws/Config/hostConnections/' + encodeURIComponent(data.originalConnectionName),
            dataType : 'json',
            contentType : 'application/json',
            cache : false,
            success : function(success) {
            	if(success) {
            		hostConnectionsTable.row('tr.row_selected').data(data);
            		if(!skipMessage) {
            			$.showSuccessStatus(updateHciSuccessText);
            		}
            	} else {
            		$.showErrorStatus(updateHciErrorText);
            	}
            },
            error : function(msg) {
            	$.showErrorStatus(msg.responseText);
            }
        });
    }
    
    var deleteSelectedRows = function() {
        $.displayLoadingIndicator(deletingText);
        
        var descriptions = '';
        var selectedRowsData = hostConnectionsTable.rows('.row_selected').data();
        var selectedGroups = [];

        for (var index = 0; index < selectedRowsData.length; index++) {
            var rowData = selectedRowsData[index];
            $.debugLog(rowData);
            descriptions += rowData.hostConnectionName + ',';
            
            if (!!rowData.group) {
                selectedGroups.push(rowData.group.groupName);
            }
        }
        
        descriptions = descriptions.substr(0, descriptions.length - 1);

        $.ajax({
            type: 'DELETE',
            url : 'ws/Config/hostConnections/' + encodeURIComponent(descriptions),
            dataType : 'json',
            cache : false,
            success : function(success) {
            	if (success) {
                    $.removeLoadingIndicator();
                    hostConnectionsTable.rows('.row_selected').remove();
                    hostConnectionsTable.draw();
                    $.showSuccessStatus(deleteHciSuccessText);
            	} else {
            		$.removeLoadingIndicator();
            		$.showErrorStatus(deleteHciErrorText);
                    hostConnectionsTable.draw();
            	}
            },
            error : function() {
            	$.removeLoadingIndicator();
            	$.showErrorStatus(deleteHciErrorText);
                hostConnectionsTable.draw();
            }
        });              
    };
    
    var testConnection = function(testData) {
        var isEvent = !testData.connectionName;
        
        if (isEvent) {
            $.displayLoadingIndicator(testingText);
            // if this was called from an event trigger then we need to populate the test data 
            testData = {
                connectionName : $('#description').val().trim(),
                connectionHost : $('#hostName').val().trim(),
                connectionPort : $('#hostPort').val().trim(),
                sslConnection : parseInt($('#secureType').val())
            };
        }
        //turn all connection data into a string then encrypt it
        var testHCIdata = '';
        testHCIdata = testData.connectionName + '\n';
        testHCIdata = testHCIdata + testData.connectionHost + '\n';
        testHCIdata = testHCIdata + testData.connectionPort + '\n';
        testHCIdata = testHCIdata + testData.sslConnection;
        var encTestData = Crypto.encrypt(testHCIdata)
        
        return $.ajax({
            url : 'hostconnection/testHostConnection',
            dataType: 'json',
            data : {
            	live : encTestData.iv,
            	hostConnectionInformation : encTestData.encrypted
            },
            cache : false,
            success : function(response) {
                if (isEvent) {
                    $.removeLoadingIndicator();

                    if (!!response.message) {
                        $('#active').val(false);
                        $.showErrorStatus(response.message);
                    } else {
                        $('#active').val(true);
                        $.showSuccessStatus(connectionSuccessfulText);
                    }
                }
            }
        });
    };
    
    var showDetailsTooltip = function() {
        var rowData = hostConnectionsTable.row($($(this).parents('tr')[0])).data();

        if (!!rowData) {
            $.displayLoadingIndicator(loadingDetailsText);
            
            $.ajax({
                type: 'GET',
                url : 'hostconnection/getHostConnectionInfo?connectionName=' + rowData.hostConnectionName+ '&hostName=' + rowData.connectionHost+ '&port=' + rowData.connectionPort+ '&secureConnectionType=' + rowData.sslConnection,
                dataType : 'json',
                cache : true,
                success : function(response) {
                    var $detailsText = $('#detailsText');
                    $.removeLoadingIndicator();
                    
                    var data = {
                        originalConnectionName : rowData.hostConnectionName,
                        hostConnectionName : rowData.hostConnectionName,
                        connectionName : rowData.hostConnectionName,
                        connectionHost : rowData.connectionHost,
                        connectionPort : rowData.connectionPort,
                        group : rowData.group,
                        sslConnection : rowData.sslConnection
                    };                   
                    
                    data.active = (response.success ? true : false);
                    updateRow(data, true);          
                    
                    if (!response || !response.success) {
                        $detailsText.text(infoNotAvailable);
                        $detailsText.show();
                    } else if (Object.keys(response).length === 1) {
                        $detailsText.text(infoNoInformation);
                        $detailsText.show();
                    } else {
                        $('.detail-info.topaz').text(!!response.Topaz ? licensedText : unlicensedText);
                        $('.detail-info.fileaid').text(!!response.TopazFileAID ? licensedText : unlicensedText);
                        $('.detail-info.enterprise-data').text(!!response.TopazEnterpriseData ? licensedText : unlicensedText);
                        $('.detail-info.program-analysis').text(!!response.TopazProgramAnalysis ? licensedText : unlicensedText);
                        $('.detail-info.topaz-for-java').text(!!response.TopazJavaPerformance ? licensedText : unlicensedText);
                        $('.detail-info.topaz-for-total-test').text(!!response.TopazTotalTest ? licensedText : unlicensedText);
                        $('.detail-info.api-version').text(response.CSSAPIVersion);
                        $('.detail-info.product-version').text(response.CSSProductVersion);
                        $('.detail-info.lpar-name').text(response.LPARName);
                        $('.detail-info.job-id').text(response.HCIJobID);
                        $('.detail-info.job-name').text(response.HCIJobName);
                        $('.detail-info.zos-datasets').text(!!response.ZOSDatasets ? supportedText : unsupportedText);
                        $('.detail-info.zos-unix-files').text(!!response.ZOSUnixFiles ? supportedText : unsupportedText);
                        $('.detail-info.endevor').text(!!response.Endevor ? supportedText : unsupportedText);
                        $('.detail-info.ispw').text(!!response.ISPW ? supportedText : unsupportedText);
                        $('#detailsContainer').show();
                    }
                }
            });
        }
    };
    
    var hideDetailsTooltip = function() {
        $('.details-tooltip').hide();
    }
    
    var validateDescription = function() {
        var errorText = '';
        var newDescription = $('#description').val();
        var newDescriptionLowerCase = newDescription.toString().toLowerCase();
        var newDescriptionNotEqualsOld = !originalDescription || newDescriptionLowerCase !== originalDescription.toString().toLowerCase();
        
        
        if (newDescription.length > 0) {
        	// contains illegal characters
			if (/^[^/\#%\/\\\?\[\]&<>"']*$/.test(newDescription) !== true) {
                errorText = descriptionCharErrorText;
            }
        	// starts with whitespace
            else  if (newDescription.search(/^\s/g) !== -1) {
                errorText = descriptionStartErrorText;
            }
        	// ends with whitespace
            else if (newDescription.search(/\s$/g) !== -1) {
                errorText = descriptionEndErrorText;
            }
            else if (newDescriptionNotEqualsOld && !!descriptions) {
                for (var index = 0; index <  descriptions.length; index++) {
                    var description = descriptions[index];
                    
                    if (description.toString().toLowerCase() === newDescriptionLowerCase) {
                        errorText = descriptionErrorText;
                        break;
                    }
                }
            }
        } else if (descriptionEdited) {
            errorText = descriptionRequiredErrorText;
        }
        
        return errorText;
    };
    
    var validateHostName = function() {
        var errorText = '';
        var newHostName = $('#hostName').val();
        
        if (newHostName.length > 0) {
        	// contains whitespace
        	if(newHostName.search(/\s/g) !== -1) {
                errorText = hostNameErrorText;
            }
        } else if (hostNameEdited) {
            errorText = hostNameRequiredErrorText;
        }
      
        return errorText;
    };
    
    var validatePort = function() {
        var errorText = '';
        var portNumber = $('#hostPort').val();
        
        if (portNumber.length > 0) {
            var nonDigitCharacterIndex = portNumber.search(/\D/g);
            
            if (nonDigitCharacterIndex === -1) {
                //it's all digits
                var portNumberValue = parseInt(portNumber);
                
                if (portNumberValue < 0 || portNumberValue > 65535) {
                    //it's out of range
                    errorText = portErrorText;
                }
            } else {
                //it contains non-digit characters
                errorText = portErrorText;
            }
        } else if (portEdited) {
            errorText = portRequiredErrorText;
        }
        
        return errorText;
    };
    
    var validateDialogFields = function(invokerID) {
        if (invokerID === 'description') {
            descriptionEdited = true;
            
            if (!!hostData) {
                //if there is host data then this is an edit session
                //so as soon as one field has been edited then all
                //fields are considered edited
                hostNameEdited = true;
                portEdited = true;
            }
        } else if (invokerID === 'hostName') {
            hostNameEdited = true;
            
            if (!!hostData) {
                //if there is host data then this is an edit session
                //so as soon as one field has been edited then all
                //fields are considered edited
                descriptionEdited = true;
                portEdited = true;
            }
        } else if (invokerID === 'hostPort') {
            portEdited = true;
            
            if (!!hostData) {
                //if there is host data then this is an edit session
                //so as soon as one field has been edited then all
                //fields are considered edited
                descriptionEdited = true;
                hostNameEdited = true;
            }
        }
        
        if (descriptionEdited || hostNameEdited || portEdited) {
            var descriptionIsValid = true;
            var errorText = validateDescription();
            
            if (errorText.trim().length === 0) {
                if ($('#description').hasClass('invalid')) {
                    //it's currently invalid so clear the error message
                    $.clearStatus();
                    $('#description').removeClass('invalid');
                }
                
                if (!descriptionEdited) {
                    //if this field has been edited yet then it can't be validated
                    descriptionIsValid = false;
                }
            } else {
                descriptionIsValid = false;
                $.showErrorStatus(errorText);

                if (!$('#description').hasClass('invalid')) {                
                    $('#description').addClass('invalid');
                }
            }
            
            var hostNameIsValid = true;
            errorText = validateHostName();
            
            if (errorText.trim().length === 0) {
                if ($('#hostName').hasClass('invalid')) {
                    if (descriptionIsValid) {
                        //this is currently the only invalid field so clear the error message
                        $.clearStatus();
                    }
                    
                    $('#hostName').removeClass('invalid');
                }
                
                if (!hostNameEdited) {
                    //if this field has been edited yet then it can't be validated
                    hostNameIsValid = false;
                }
            } else {
                hostNameIsValid = false;
                
                if (descriptionIsValid || $('#hostName').is(':focus')) {
                    //we only need to display this if the field above is valid or this field has the focus
                    $.showErrorStatus(errorText);
                }

                if (!$('#hostName').hasClass('invalid')) {                
                    $('#hostName').addClass('invalid');
                }
            }
            
            var portNumberIsValid = true;
            errorText = validatePort();
            
            if (errorText.trim().length === 0) {
                if ($('#hostPort').hasClass('invalid')) {
                    if (descriptionIsValid && hostNameIsValid) {
                        //this is currently the only invalid field so clear the error message
                        $.clearStatus();
                    }
                    
                    $('#hostPort').removeClass('invalid');
                }
                
                if (!portEdited) {
                    //if this field has been edited yet then it can't be validated
                    portNumberIsValid = false;
                }
            } else {
                portNumberIsValid = false;

                if (descriptionIsValid && hostNameIsValid || $('#hostPort').is(':focus')) {
                    //we only need to display this if the fields above are valid or this field has the focus
                    $.showErrorStatus(errorText);
                }
                
                if (!$('#hostPort').hasClass('invalid')) {                
                    $('#hostPort').addClass('invalid');
                }
            }
            
            if (descriptionIsValid && hostNameIsValid && portNumberIsValid) {
                $.clearStatus();
                $('#testButton').removeAttr('disabled');
                $('#okButton').removeAttr('disabled');
            } else {
                $('#testButton').attr('disabled', 'disabled');
                $('#okButton').attr('disabled', 'disabled');
            }
        } else {
            //The dialog has just been opened so no fields have been edited yet.
            if (!hostData) {
                $('#testButton').attr('disabled', 'disabled');
            }
            
            $('#okButton').attr('disabled', 'disabled');
        }
    }
    
    var enableDialogButtons = function() {
        validateDialogFields($(this).attr('id'));
    };
    
    var dialogFieldFocusGained = function() {
        if ($(this).hasClass('invalid')) {
            var inputID = $(this).attr('id');
            var errorMessage = '';
            
            if (inputID === 'description') {
                errorMessage = validateDescription();
            } else if (inputID === 'hostName') {
                errorMessage = validateHostName();
            } else if (inputID === 'hostPort') {
                errorMessage = validatePort();
            }
            
            if (errorMessage.trim().length > 0) {
                $.showErrorStatus(errorMessage);
            }
        } else {
            $.clearStatus();
        }
    };
    
    var showDialog = function() {
        var tableData = hostConnectionsTable.rows().data();
        descriptions = [];
        
        for (var index = 0; index < tableData.length; index++) {
            descriptions.push(tableData[index].hostConnectionName);
        }
        
        var $dialog = $('#definitionDialog');
        var parentHeight = $dialog.closest('body')[0].scrollHeight;
        
        $dialog.fadeIn(ANIMATION_SPEED);
        var height = $dialog[0].scrollHeight;
        var adjustedHeight = Math.max(parentHeight, height) - (parentHeight >= height ? 52 : 0);
        
        $dialog.css('height',  adjustedHeight + 'px');
        
        if ($(this).attr('id') === 'hostConnectionsEditButton') {
            hostData = hostConnectionsTable.row('tr.row_selected').data();
            descriptionEdited = true;
            hostNameEdited = true;
            portEdited = true;
            
            originalDescription = hostData.hostConnectionName;
            $('#description').val(originalDescription);
            $('#hostName').val(hostData.connectionHost);
            $('#hostPort').val(hostData.connectionPort);
            $("#secureType").val(hostData.sslConnection)
        }
        
        $('#description').focus();
        
        if (isSecurityEnabled) {
            populateGroupsTable();
        } else {
            $('#securityGroupsWrapper').hide();
        }
        
        enableDialogButtons();
    };
    
    var closeDialog = function() {
        $.clearStatus();
        
        $('#definitionDialog').fadeOut(ANIMATION_SPEED, function() {
            descriptions = [];
            hostData = null;
            descriptionEdited = false;
            hostNameEdited = false;
            portEdited = false;
            
            if (isSecurityEnabled) {
                groupsTable.clear();
            }
            
            $('#active').val(null);
            
            $('#description').val('');
            $('#description').removeClass('invalid');
            
            $('#hostName').val('');
            $('#hostName').removeClass('invalid');
            
            $('#hostPort').val('');
            $('#hostPort').removeClass('invalid');
            
            $('#testButton').removeAttr('disabled');
            $('#okButton').removeAttr('disabled');
        });
    };
    
    var persistConnection = function() {
        var activeValue = $('#active').val().trim();
        var data = {
            originalConnectionName : originalDescription,
            hostConnectionName : $('#description').val().trim(),
            group : [],
            connectionHost : $('#hostName').val().trim(),
            connectionPort : $('#hostPort').val().trim(),
            active : activeValue.length > 0 ? activeValue : null,
            sslConnection : parseInt($('#secureType').val())
        };

        if (isSecurityEnabled) {
            var groupsData = groupsTable.rows().data();
            
            for (var index = 0; index < groupsData.length; index++) {
                var groupInfo = groupsData[index];
                
                if (groupInfo.checkedOne) {
                    data.group.push({groupName : groupInfo.nameOne});
                }
                
                if (groupInfo.checkedTwo) {
                    data.group.push({groupName : groupInfo.nameTwo});
                }
            }
        } else {
            data.group = null;
        }
        
        $.debugLog(data);
        
        if (!!hostData) {
            //editing a host connection
            $.displayLoadingIndicator(updatingText);
            
            updateRow(data).always(function() {
                $.removeLoadingIndicator();
            });
        } else {
            //adding a host connection
            addRow(data);
        }
        
        closeDialog();
    };
    
    // The document has finished loading, let's do our stuff
    $(document).ready(function() {
        var noCacheInformation = {nocache : new Date().getTime()};
        var hostConnectionsParameters = {showall : true, nocache : new Date().getTime()};
        $.displayLoadingIndicator(loadingText);
        toggleDataTemplate = $('#toggleDataTemplate').html().trim();
        
        $.when(
            $.getJSON('ws/Config/hostConnections', hostConnectionsParameters),
            $.getJSON('ws/security/groups', noCacheInformation)
        ).done(function(responseData, groupsData) {
            var response = responseData[0];
            var groupsResponse = groupsData[0];
            var connections = [];
            
            if (!!response.HostConnectionInfoResponse.hostConnectionInfoList) { 
                if ($.isArray(response.HostConnectionInfoResponse.hostConnectionInfoList.hostConnectionInfo)) {
                    connections = response.HostConnectionInfoResponse.hostConnectionInfoList.hostConnectionInfo;
                } else {
                    connections = [response.HostConnectionInfoResponse.hostConnectionInfoList.hostConnectionInfo];
                }
                
            } else if (response.HostConnectionInfoResponse.returnCode !== 0) {
                $.showErrorStatus(response.HostConnectionInfoResponse.description + " (Return Code: " + response.HostConnectionInfoResponse.returnCode + ", Reason Code: " + response.HostConnectionInfoResponse.reasonCode + ")" );
            }

            if (!!groupsResponse) {
                var groupList = groupsResponse.groupList;

                if (!!groupList) {
                    if (!$.isArray(groupList)) {
                        groups.push(groupList);
                    } else {
                        groups = groupList;
                    }
                }
            }
            
            var headers = [{
                title : statusColumnText 
            }, {
                title : descriptionColumnText 
            }, {
                title : hostnameColumnText 
            }, {
                title : portColumnText 
            }, {
                title : protocolColumnText 
            }];
             
            var hostConnectionsTableOptions = {
                columns : [
                    {
                        data : 'active',
                        className: 'dt-center',
                        render : function(data) {
                            if (data == null) {
                                return '<i class="fa fa-question status-unknown" title="' + statusUnknown + '" aria-hidden="true"></i><span class="sr-only">' + statusUnknown + '</span>';
                            } else if (data == "true" || data == true) {
                                return '<i class="fa fa-arrow-up status-init" title="' + statusActive + '" aria-hidden="true"></i><span class="sr-only">' + statusActive + '</span>';
                            } else {
                                return '<i class="fa fa-arrow-down status-term" title="' + statusInactive + '" aria-hidden="true"></i><span class="sr-only">' + statusInactive + '</span>';
                            }
                        }
                    },
                    {
                        data : 'hostConnectionName',
                        className : 'group-desc',
                    },
                    {
                        data : 'connectionHost'
                    },
                    {
                        data : 'connectionPort',
                        className : 'right-align-cell'
                    },
                    {
                        data : 'sslConnection',
                        render : function(data) {
                            var displayed = '';
                            
                            switch (data) {
                                case 1: 
                                    displayed = 'Auto'; 
                                    break;
                                case 2: 
                                    displayed = 'TLSv1.2'; 
                                    break;
                                case 3: 
                                    displayed = 'TLSv1.1'; 
                                    break;
                                case 4: 
                                    displayed = 'TLSv1'; 
                                    break;
                                case 5: 
                                    displayed = 'TLS'; 
                                    break;
                                case 6: 
                                    displayed = 'SSLv3';
                                    break;
                                default: 
                                    displayed = 'None';
                                    break;
                            }
                            
                            return '<div class="details-toggle  fa fa-info-circle hidden"></div><span class="details-col-text">' + displayed + '</span>';
                        }
                    }
                ],
                order : [[0, 'asc']],
                data : connections
            };
            
          //We only display the groups column if security is on
    		if(isSecurityEnabled) {
    			hostConnectionsTableOptions.columns.splice(1, 0, {
    				data : 'group',
                    className : 'group-data',
                    render : function(group) {
                        if (!!group) {
                            var groupArray = group;
                            
                            if (!$.isArray(groupArray)) {
                                groupArray = [];
                                groupArray.push(group);
                            }
                            
                            if (groupArray.length > 0) {
                                var groupNames = groupArray.map(function(item) {
                                    return item.groupName;
                                });
                                
                                return groupNames.join(', ');
                            } else {
                                return noGroupText;
                            }
                        } else {
                            return noGroupText;
                        }
                    },
                    defaultContent : noGroupText
    			});
    			headers.splice(1, 0, {
    				title: groupColumnText
    			});
    		}
            
            var tableControls = {
                addButton : {
                    clazz : 'add-button',
                    callback : showDialog
                },
                editButton : {
                    clazz : 'edit-button',
                    callback : showDialog,
                    disabled : 'disabled',
                    enablement : 'single'
                },
                deleteButton : {
                    clazz : 'delete-button',
                    disabled : 'disabled',
                    enablement : 'multi',
                    deleteConfirmationCallback : deleteSelectedRows
                }  
            };
            
            var hostConnectionsTableComponent = new SimpleTableComponent('hostConnections', '#hostConnectionsTableContainer', headers, {toolbarContainerId : 'hostConnectionsTableToolbar'});
            hostConnectionsTable = hostConnectionsTableComponent.createTable(hostConnectionsTableOptions, 'multi', null, null, tableControls);
            
            var eventHistoryElement = document.createElement('a');
            eventHistoryElement.setAttribute('href', 'jsp/settings/eventHistory.jsp');
            eventHistoryElement.setAttribute('id', 'eventHistory');
            
            var eventHistoryButton = document.createElement('button');
            eventHistoryButton.setAttribute('class', 'fa fa-history table-toolbar-item');
            eventHistoryButton.setAttribute('title', eventHistoryTooltip);
            eventHistoryButton.setAttribute('aria-label', eventHistoryTooltip);
            eventHistoryElement.appendChild(eventHistoryButton);
            document.getElementById('hostConnectionsTableToolbar').appendChild(eventHistoryElement);
            
            // add handlers to display additional information
            $('#hostConnectionsTable').on('click', 'div.details-toggle', showDetailsTooltip );
            $('#testButton').click(testConnection);
            $('#okButton').click(persistConnection);
            $('#cancelButton').click(closeDialog);
            $('html').on('click', hideDetailsTooltip);
            $('#groupsTable').on('click', '.switch-input', function() {
                var id = this.dataset.id;
                var checked = $(this).prop('checked');
               
                groupsTable.rows().data().map(function(data){
                    data.idOne == id ? data.checkedOne = checked : null;
                    data.idTwo == id ? data.checkedTwo = checked : null;
                })
            });
            $('#definitionDialog input').on('click', function(event){event.stopPropagation();});
            $("html").on("click", function(){$.clearStatus();});
            $('#description, #hostName, #hostPort').on('input', enableDialogButtons);
            $('#description, #hostName, #hostPort').focusin(dialogFieldFocusGained);
        }).always(function() {
            $.removeLoadingIndicator();
        });
    });
})(jQuery);